/* eslint-env browser */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const host = 'https://webtools.au.dk';

export const backendApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: `${host}/api/` }),
  tagTypes: [],
  endpoints: (builder) => ({
    getAutoSuggests: builder.query<string[], void>({
      query: () => 'service/AutoSuggests',
    }),
    getService: builder.query<IServiceResult, string>({
      query: (query: string) => `service/search?query=${query}`,
    }),
  }),
});

export const { useGetAutoSuggestsQuery, useGetServiceQuery } = backendApi;
